import { BrowserRouter } from "react-router-dom";
import { Security } from "@okta/okta-react";
import { toRelativeUrl, OktaAuth } from "@okta/okta-auth-js";
import OktaLoginRoute from "../okta/OktaLoginRoute";
import { oktaAuth } from "../okta/authService";
import * as Styles from './styles';
import UnifyThemeProvider from "../theme/UnifyThemeProvider";
import { useEffect, useState } from "react";
import eventEmitter from "./eventEmitter";
import ErrorHandlingDialog from "../common/ErrorDialog";
import OktaEventListener from "./OktaEventListener";
import "../i18n/i18n";


export async function restoreOriginalUri(
  _oktaAuth: OktaAuth,
  originalUri?: string
): Promise<void> {
  const url = toRelativeUrl(
    originalUri || "/unify",
    window.location.origin
  );
  window.location.replace(url);
}


const ApiErrorListener = () => {
  const [isOpen,setIsOpen] = useState(false);
  useEffect(() => {
    const errorListener = async () => {
      setIsOpen(true);
    };
    eventEmitter.on("bffError", errorListener);
    return () => {
      eventEmitter.off("bffError", errorListener);
    };
  }, []);

  
  return <>
      <ErrorHandlingDialog isOpen={isOpen} onClose={()=> setIsOpen(false)} onReload={()=>window.location.reload()} ></ErrorHandlingDialog>
    </>; 
};

function UnifyApp() {

  return (
    
    <Styles.App>
      <BrowserRouter>
      <UnifyThemeProvider>
        <Security
          oktaAuth={oktaAuth}
          restoreOriginalUri={restoreOriginalUri}
        >
          <OktaEventListener></OktaEventListener>
          <ApiErrorListener></ApiErrorListener>
          <OktaLoginRoute></OktaLoginRoute>
        </Security>
        </UnifyThemeProvider>
      </BrowserRouter>
    </Styles.App>
    
  );
}

export default UnifyApp;
